import React from "react";
import "./../../../assets/css/mentor/HowMentorshipworks/howmentorshipworks.css";

const HowMentorshipWorks = () => {
  // Step flow data
  const steps = [
    {
      id: 1,
      title: "Choose Your Goal",
      description: "Define what you want to learn or achieve",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            d="M22 11.08V12a10 10 0 1 1-5.93-9.14"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            points="22 4 12 14.01 9 11.01"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 2,
      title: "Get Matched With a Mentor",
      description: "Find the perfect mentor for your journey",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="9"
            cy="7"
            r="4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23 21v-2a4 4 0 0 0-3-3.87"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 3.13a4 4 0 0 1 0 7.75"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 3,
      title: "Create a Learning Plan",
      description: "Build a personalized roadmap together",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            points="14 2 14 8 20 8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="16"
            y1="13"
            x2="8"
            y2="13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="16"
            y1="17"
            x2="8"
            y2="17"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            points="10 9 9 9 8 9"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 4,
      title: "Book 1-on-1 Sessions",
      description: "Schedule sessions at your convenience",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect
            x="3"
            y="4"
            width="18"
            height="18"
            rx="2"
            ry="2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="16"
            y1="2"
            x2="16"
            y2="6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="8"
            y1="2"
            x2="8"
            y2="6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="3"
            y1="10"
            x2="21"
            y2="10"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 5,
      title: "Track Your Growth",
      description: "Monitor progress and achieve milestones",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <polyline
            points="22 12 18 12 15 21 9 3 6 12 2 12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  // Two paths data
  const learnerFeatures = [
    "Choose a skill you want to master",
    "Browse verified mentors in your field",
    "Get personalized guidance tailored to you",
    "Learn with a structured roadmap",
    "Receive continuous feedback and support",
  ];

  const mentorFeatures = [
    "Apply to become a mentor",
    "Complete our verification process",
    "Set your availability and rates",
    "Guide students to reach their goals",
    "Build your reputation and earn income",
  ];

  // Why mentorship features
  const whyFeatures = [
    {
      id: 1,
      title: "Personalized Learning",
      description:
        "Get a learning path tailored specifically to your goals, background, and learning style.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="7"
            r="4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 2,
      title: "Real Industry Professionals",
      description:
        "Learn from experienced mentors actively working in top tech companies and startups.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="9"
            cy="7"
            r="4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23 21v-2a4 4 0 0 0-3-3.87"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 3.13a4 4 0 0 1 0 7.75"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 3,
      title: "Practical Guidance",
      description:
        "Get hands-on help with real projects, code reviews, and career decisions that matter.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <polyline
            points="9 11 12 14 22 4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: 4,
      title: "Career-Focused Outcomes",
      description:
        "Focus on skills and experiences that directly advance your career in technology.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <line
            x1="12"
            y1="1"
            x2="12"
            y2="23"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="hmw-page">
      {/* Hero Section */}
      <section className="hmw-hero-section">
        <div className="hmw-hero-container">
          <h1 className="hmw-hero-title">How Mentorship Works</h1>
          <p className="hmw-hero-subtitle">
            A simple, guided approach to learn, grow, and achieve your goals.
          </p>
        </div>
      </section>

      {/* Step Flow Section */}
      <section className="hmw-steps-section">
        <div className="hmw-steps-container">
          <div className="hmw-steps-grid">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div className="hmw-step-card">
                  <div className="hmw-step-number">{step.id}</div>
                  <div className="hmw-step-icon-wrapper">{step.icon}</div>
                  <h3 className="hmw-step-title">{step.title}</h3>
                  <p className="hmw-step-description">{step.description}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hmw-step-connector">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <line
                        x1="5"
                        y1="12"
                        x2="19"
                        y2="12"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <polyline
                        points="12 5 19 12 12 19"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* Two Paths Section */}
      <section className="hmw-paths-section">
        <div className="hmw-paths-container">
          <h2 className="hmw-paths-heading">Choose Your Path</h2>
          <div className="hmw-paths-grid">
            {/* For Learners */}
            <div className="hmw-path-card">
              <div className="hmw-path-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    d="M22 10v6M2 10l10-5 10 5-10 5z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 12v5c3 3 9 3 12 0v-5"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3 className="hmw-path-title">For Learners</h3>
              <ul className="hmw-path-features">
                {learnerFeatures.map((feature, index) => (
                  <li key={index} className="hmw-path-feature">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline
                        points="20 6 9 17 4 12"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <button className="hmw-path-button hmw-path-button-primary">
                Find a Mentor
              </button>
            </div>

            {/* For Mentors */}
            <div className="hmw-path-card">
              <div className="hmw-path-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3 className="hmw-path-title">For Mentors</h3>
              <ul className="hmw-path-features">
                {mentorFeatures.map((feature, index) => (
                  <li key={index} className="hmw-path-feature">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline
                        points="20 6 9 17 4 12"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <button className="hmw-path-button hmw-path-button-secondary">
                Become a Mentor
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Why Mentorship Section */}
      <section className="hmw-why-section">
        <div className="hmw-why-container">
          <h2 className="hmw-why-heading">Why Choose Mentorship?</h2>
          <p className="hmw-why-subheading">
            One-on-one guidance accelerates your learning and career growth
          </p>
          <div className="hmw-why-grid">
            {whyFeatures.map((feature) => (
              <div key={feature.id} className="hmw-why-card">
                <div className="hmw-why-icon">{feature.icon}</div>
                <h3 className="hmw-why-title">{feature.title}</h3>
                <p className="hmw-why-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="hmw-cta-section">
        <div className="hmw-cta-container">
          <h2 className="hmw-cta-heading">
            Ready to start your mentorship journey?
          </h2>
          <p className="hmw-cta-subheading">
            Join thousands of learners and mentors growing together
          </p>
          <div className="hmw-cta-buttons">
            <button className="hmw-cta-button hmw-cta-button-primary">
              Find a Mentor
            </button>
            <button className="hmw-cta-button hmw-cta-button-secondary">
              Become a Mentor
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowMentorshipWorks;
